import React from 'react'
import { Form } from 'antd'
import { useTranslation } from 'lib/i18n'

import { VIDEO_REQUEST_CUSTOM_REQUEST_OCCASION } from 'components/ProductPage/shared/FieldConstants'

import InputWithoutAutoComplete from '../InputWithoutAutoComplete/InputWithoutAutoComplete'

import styles from './CustomOccasionInput.module.css'

type CustomOccasionInputProps = {
  isMarketingRequest?: boolean
}

const CustomOccasionInput = ({
  isMarketingRequest = false,
}: CustomOccasionInputProps): JSX.Element => {
  const { t } = useTranslation()

  return (
    <Form.Item
      name={VIDEO_REQUEST_CUSTOM_REQUEST_OCCASION}
      label={
        isMarketingRequest
          ? t('occasion.subtitleMarketing', 'Campaign name')
          : t('occasion.subtitle2', 'Occasion name')
      }
      data-cy="customInstruction"
      className={styles.input}
    >
      <InputWithoutAutoComplete
        size="large"
        placeholder={
          isMarketingRequest
            ? t('occasion.subtitleMarketingCampaign', 'Your campaign')
            : t('occasion.yourOccasion', 'Your special occasion')
        }
        maxLength={30}
      />
    </Form.Item>
  )
}

export default CustomOccasionInput
